import { render } from "./PActionDialog.vue?vue&type=template&id=a1b3cc42"
import script from "./PActionDialog.vue?vue&type=script&lang=js"
export * from "./PActionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__